import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Footer } from '../Footer';
import { Container } from '../style';
import { Slides } from './Content';
import { WorkoutActionCreators } from '../../../../Store/ActionCreators/WorkoutsActionCreators';
import { Spinner } from '../../../Components/Spiner/Spiner';

class GymTv extends Component {
    state = {
        currentIndex: 0,
    };

    componentDidMount() {
        this.props.getWorkout();
    }

    getMetric = index => {
        switch (index) {
            case 0:
                return '% Max heartrate';
            case 1:
                return 'Calories burned';
            case 2:
                return 'Heartrate';
            default:
                return 'Unknown';
        }
    };

    getCurrentSlide = currentIndex => {
        this.setState({ currentIndex });
    };

    render() {
        const {
            state: { currentIndex },
            props: { workoutInfo, workoutOwner, workoutInfoLoading },
            getMetric,
            getCurrentSlide,
        } = this;
        return (
            <Container isEmbed={this.props.isEmbed}>
                {workoutInfoLoading ? (
                    <Spinner />
                ) : (
                    <React.Fragment>
                        <Slides
                            isEmbed={this.props.isEmbed}
                            workoutId={workoutInfo.id}
                            getCurrentSlide={getCurrentSlide}
                        />
                        <Footer
                            displayBoardType={true}
                            workoutOwner={workoutOwner}
                            workoutInfo={workoutInfo}
                            boardType={getMetric(currentIndex)}
                        />
                    </React.Fragment>
                )}
            </Container>
        );
    }
}

const mapStateToProps = (
    {
        workout: {
            id,
            statuses: { workoutInfoLoading },
            currentWorkouts,
            user,
            ...workoutInfo
        },
    },
    props,
) => {
    const workoutId = props.currentWorkoutId || props.match.params.workoutId;
    let workout = {};

    Object.values(currentWorkouts).forEach(wOut => {
        if (wOut.id == workoutId) workout = { ...wOut };
    });

    return {
        workoutInfoLoading,
        workoutId: workout.id,
        workoutInfo: workout,
        workoutOwner: workout.user,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    const workoutId = props.currentWorkoutId || props.match.params.workoutId;

    return {
        getWorkout: () => dispatch(WorkoutActionCreators.getByIdRequest(workoutId)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(GymTv);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/LiveDisplay/index.js